(function () {
  var root = document.body && document.body.classList.contains('template-santi-mini-offer')
    ? document.getElementById('MainContent')
    : document.querySelector('[data-santi-mini-offer]');
  if (!root || root.getAttribute('data-smo-bound') === 'true') return;
  root.setAttribute('data-smo-bound', 'true');

  function suppressCampaignPopup() {
    var dialogs = document.querySelectorAll(
      '[role="dialog"][aria-label="POPUP Form"][data-kl-scroll-locking-modal="true"]'
    );
    var suppressed = false;

    Array.prototype.forEach.call(dialogs, function (dialog) {
      if (!dialog.parentNode) return;
      dialog.parentNode.removeChild(dialog);
      suppressed = true;
    });

    if (document.body.classList.contains('klaviyo-prevent-body-scrolling')) {
      document.body.classList.remove('klaviyo-prevent-body-scrolling');
      suppressed = true;
    }

    if (document.body.style.overflow === 'hidden') {
      document.body.style.removeProperty('overflow');
    }

    if (suppressed) {
      document.body.setAttribute('data-smo-campaign-popup-suppressed', 'true');
    }
  }

  suppressCampaignPopup();
  if (typeof MutationObserver === 'function') {
    var popupObserver = new MutationObserver(suppressCampaignPopup);
    popupObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  Array.prototype.forEach.call(document.querySelectorAll('.site-header a[href="/"]'), function (link) {
    if (!link.getAttribute('aria-label') && !link.textContent.trim()) {
      link.setAttribute('aria-label', 'Santi the Sloth home');
    }
  });

  var heroCta = root.querySelector('.smo-hero .smo-button');
  var chatShadowRoot = null;
  var chatShadowObserver = null;
  var chatUpdateQueued = false;

  function rectanglesOverlap(first, second) {
    return Math.min(first.right, second.right) > Math.max(first.left, second.left) &&
      Math.min(first.bottom, second.bottom) > Math.max(first.top, second.top);
  }

  function updateChatOverlap() {
    chatUpdateQueued = false;
    var host = document.querySelector('shopify-chat');
    var shadowRoot = host && host.shadowRoot;
    var activator = shadowRoot && (
      shadowRoot.querySelector('.activator-nudge') ||
      shadowRoot.querySelector('.activator')
    );

    if (!host || !shadowRoot || !activator || !heroCta) return false;

    if (shadowRoot !== chatShadowRoot && typeof MutationObserver === 'function') {
      if (chatShadowObserver) chatShadowObserver.disconnect();
      chatShadowRoot = shadowRoot;
      chatShadowObserver = new MutationObserver(queueChatOverlapUpdate);
      chatShadowObserver.observe(shadowRoot, { childList: true, subtree: true });
    }

    var shouldHide = window.innerWidth <= 380 &&
      rectanglesOverlap(heroCta.getBoundingClientRect(), activator.getBoundingClientRect());

    if (shouldHide) {
      activator.style.setProperty('visibility', 'hidden', 'important');
      activator.style.setProperty('pointer-events', 'none', 'important');
      activator.setAttribute('data-smo-hidden-for-hero', 'true');
      host.setAttribute('data-smo-chat-overlap-hidden', 'true');
    } else if (activator.getAttribute('data-smo-hidden-for-hero') === 'true') {
      activator.style.removeProperty('visibility');
      activator.style.removeProperty('pointer-events');
      activator.removeAttribute('data-smo-hidden-for-hero');
      host.removeAttribute('data-smo-chat-overlap-hidden');
    }

    return true;
  }

  function queueChatOverlapUpdate() {
    if (chatUpdateQueued) return;
    chatUpdateQueued = true;
    window.requestAnimationFrame(updateChatOverlap);
  }

  var chatGuardAttempts = 0;
  var chatGuardTimer = window.setInterval(function () {
    chatGuardAttempts += 1;
    if (updateChatOverlap() || chatGuardAttempts >= 40) {
      window.clearInterval(chatGuardTimer);
    }
  }, 250);

  window.addEventListener('scroll', queueChatOverlapUpdate, { passive: true });
  window.addEventListener('resize', queueChatOverlapUpdate);

  window.dataLayer = window.dataLayer || [];

  function readUtmParam(name) {
    try {
      return new URL(window.location.href).searchParams.get(name) || '';
    } catch (error) {
      return '';
    }
  }

  function utmPayload() {
    return {
      utm_source: readUtmParam('utm_source'),
      utm_medium: readUtmParam('utm_medium'),
      utm_campaign: readUtmParam('utm_campaign'),
      utm_content: readUtmParam('utm_content'),
      utm_term: readUtmParam('utm_term')
    };
  }

  function offerBasePayload(name, params) {
    return Object.assign({
      event: name,
      page_type: 'paid_landing_page',
      landing_page: 'santi-mini-offer'
    }, utmPayload(), params || {});
  }

  function emitOfferEvent(name, params) {
    var payload = offerBasePayload(name, params);

    window.dataLayer.push(payload);

    if (typeof window.gtag === 'function') {
      var gtagParams = Object.assign({}, payload);
      delete gtagParams.event;
      window.gtag('event', name, gtagParams);
    }

    if (typeof window.hj === 'function') {
      window.hj('event', name);
    }
  }

  function emitOfferAlias(name, params, sendToGtag) {
    var payload = Object.assign(offerBasePayload(name, params), {
      legacy_event: true
    });

    window.dataLayer.push(payload);

    if (sendToGtag && typeof window.gtag === 'function') {
      var gtagParams = Object.assign({}, payload);
      delete gtagParams.event;
      window.gtag('event', name, gtagParams);
    }
  }

  function selectedOption(select) {
    if (!select || select.selectedIndex < 0) return null;
    return select.options[select.selectedIndex];
  }

  function moneyFromCard(card) {
    var price = card.querySelector('[data-smo-kit-price-label]');
    if (!price) price = card.querySelector('.smo-bundle-card__price');
    return price ? price.textContent.trim() : '';
  }

  function readCardName(card) {
    var form = card.querySelector('[data-smo-bundle-form], [data-bundle-form]');
    var heading = card.querySelector('h3');
    return card.getAttribute('data-item-name') ||
      (form && form.getAttribute('data-bundle-name')) ||
      (heading ? heading.textContent.trim() : '');
  }

  function readCardPrice(card) {
    var form = card.querySelector('[data-smo-bundle-form], [data-bundle-form]');
    return card.getAttribute('data-price') ||
      (form && form.getAttribute('data-bundle-price')) ||
      '';
  }

  function readCardVariantId(card) {
    var input = card.querySelector('[data-smo-form-variant], input[name="id"]');
    return card.getAttribute('data-variant-id') || (input ? input.value : '');
  }

  function readCardProductId(card) {
    return card ? card.getAttribute('data-product-id') || '' : '';
  }

  function readCardVariant(card) {
    return card ? card.getAttribute('data-item-variant') || '' : '';
  }

  function readCardCurrency(card) {
    return card ? card.getAttribute('data-currency') || '' : '';
  }

  function readCardPosition(card, cards) {
    var index = cards.indexOf(card);
    return index >= 0 ? index + 1 : null;
  }

  function bundleEventParams(card, cards, source) {
    return {
      bundle_name: readCardName(card),
      item_name: readCardName(card),
      item_id: readCardVariantId(card),
      product_id: readCardProductId(card),
      item_variant: readCardVariant(card),
      bundle_price: readCardPrice(card),
      price: readCardPrice(card),
      currency: readCardCurrency(card),
      bundle_position: readCardPosition(card, cards),
      source: source || 'bundle_card'
    };
  }

  function isCardAvailable(card) {
    var addButton = card.querySelector('[data-smo-kit-add], .smo-bundle-card__form button[type="submit"]');
    if (card.hasAttribute('data-available')) {
      return card.getAttribute('data-available') === 'true';
    }
    return addButton ? !addButton.disabled : true;
  }

  function cardImage(card) {
    return card ? card.querySelector('.smo-bundle-card__media img') : null;
  }

  function ensureStickyImage(slot) {
    if (!slot) return null;
    var image = slot.querySelector('[data-smo-sticky-image]');
    if (!image) {
      image = document.createElement('img');
      image.alt = '';
      image.width = 46;
      image.height = 46;
      image.hidden = true;
      image.setAttribute('data-smo-sticky-image', '');
      slot.appendChild(image);
    }
    return image;
  }

  function createStickyAtc(selector) {
    var form = document.createElement('form');
    form.method = 'post';
    form.action = '/cart/add';
    form.className = 'smo-sticky-atc';
    form.setAttribute('data-smo-sticky-atc', '');
    form.setAttribute('data-smo-bundle-form', '');

    var variantInput = document.createElement('input');
    variantInput.type = 'hidden';
    variantInput.name = 'id';
    variantInput.setAttribute('data-smo-sticky-variant', '');
    form.appendChild(variantInput);

    var quantityInput = document.createElement('input');
    quantityInput.type = 'hidden';
    quantityInput.name = 'quantity';
    quantityInput.value = '1';
    form.appendChild(quantityInput);

    var productIcon = document.createElement('span');
    productIcon.className = 'smo-sticky-atc__product-icon';
    productIcon.setAttribute('aria-hidden', 'true');

    var imageSlot = document.createElement('span');
    imageSlot.setAttribute('data-smo-sticky-image-slot', '');
    productIcon.appendChild(imageSlot);

    var fallbackIcon = document.createElement('span');
    fallbackIcon.setAttribute('data-smo-sticky-icon', '');
    var icon = selector.querySelector('.santi-mini-icon');
    if (icon) fallbackIcon.appendChild(icon.cloneNode(true));
    productIcon.appendChild(fallbackIcon);
    form.appendChild(productIcon);

    var summary = document.createElement('span');
    summary.className = 'smo-sticky-atc__summary';

    var title = document.createElement('span');
    title.className = 'smo-sticky-atc__title';
    title.setAttribute('data-smo-sticky-title', '');
    title.textContent = 'Choose your Santi Mini';

    var price = document.createElement('span');
    price.className = 'smo-sticky-atc__price';
    price.setAttribute('data-smo-sticky-price', '');
    price.textContent = 'Select a bundle';

    summary.appendChild(title);
    summary.appendChild(price);
    form.appendChild(summary);

    var button = document.createElement('button');
    button.className = 'smo-sticky-atc__button';
    button.type = 'submit';
    button.setAttribute('data-smo-sticky-add', '');
    button.disabled = true;
    button.textContent = 'Add selected bundle';
    form.appendChild(button);

    selector.appendChild(form);
    return form;
  }

  function updateVariant(card) {
    var select = card.querySelector('[data-smo-kit-variant-select]');
    var option = selectedOption(select);
    var hiddenInput = card.querySelector('[data-smo-form-variant]');
    var currentPrice = card.querySelector('[data-smo-price-current]');
    var comparePrice = card.querySelector('[data-smo-price-compare]');
    var addButton = card.querySelector('[data-smo-kit-add]');

    if (!option) {
      if (hiddenInput) card.setAttribute('data-variant-id', hiddenInput.value || '');
      return;
    }

    var available = option.getAttribute('data-available') === 'true';
    card.setAttribute('data-variant-id', option.value || '');
    card.setAttribute('data-sku', option.getAttribute('data-sku') || '');
    card.setAttribute('data-item-variant', option.getAttribute('data-title') || '');
    card.setAttribute('data-price-cents', option.getAttribute('data-price-cents') || '');
    card.setAttribute('data-price', option.getAttribute('data-price') || '');
    card.setAttribute('data-available', available ? 'true' : 'false');

    if (hiddenInput) hiddenInput.value = option.value || '';
    if (currentPrice) currentPrice.textContent = option.getAttribute('data-price-label') || '';
    if (comparePrice) {
      var compareLabel = option.getAttribute('data-compare-at-label') || '';
      comparePrice.textContent = compareLabel;
      comparePrice.hidden = !compareLabel;
    }
    if (addButton) addButton.disabled = !available;
  }

  function initBundleSelector(selector) {
    var cards = Array.prototype.slice.call(selector.querySelectorAll('[data-smo-kit-card], [data-bundle-card]'));
    var sticky = selector.querySelector('[data-smo-sticky-atc]');
    if (!sticky && cards.length) sticky = createStickyAtc(selector);
    if (sticky && sticky.parentElement !== document.body) {
      document.body.appendChild(sticky);
    }
    var stickyInput = sticky ? sticky.querySelector('[data-smo-sticky-variant]') : null;
    var stickyTitle = sticky ? sticky.querySelector('[data-smo-sticky-title]') : null;
    var stickyPrice = sticky ? sticky.querySelector('[data-smo-sticky-price]') : null;
    var stickyButton = sticky ? sticky.querySelector('[data-smo-sticky-add]') : null;
    var stickyImageSlot = sticky ? sticky.querySelector('[data-smo-sticky-image-slot]') : null;
    var stickyIcon = sticky ? sticky.querySelector('[data-smo-sticky-icon]') : null;
    var selectedCard = cards.filter(function (card) {
      return card.classList.contains('is-selected');
    })[0] || cards[0];

    function selectCard(card, shouldTrack) {
      if (!card) return;
      updateVariant(card);
      selectedCard = card;

      cards.forEach(function (candidate) {
        var selected = candidate === card;
        candidate.classList.toggle('is-selected', selected);
        var selectButton = candidate.querySelector('[data-smo-kit-select]');
        if (selectButton) {
          selectButton.setAttribute('aria-pressed', selected ? 'true' : 'false');
          var label = selectButton.querySelector('[data-smo-select-label]');
          if (label) label.textContent = selected ? 'Selected' : 'Select';
        }
      });

      if (stickyInput) stickyInput.value = readCardVariantId(card);
      if (stickyTitle) stickyTitle.textContent = readCardName(card);
      if (stickyPrice) stickyPrice.textContent = moneyFromCard(card);
      if (stickyButton) stickyButton.disabled = !isCardAvailable(card);
      if (stickyImageSlot) {
        var image = cardImage(card);
        var imageSrc = image ? (image.currentSrc || image.src) : '';
        var stickyImage = imageSrc ? ensureStickyImage(stickyImageSlot) : stickyImageSlot.querySelector('[data-smo-sticky-image]');
        if (imageSrc && stickyImage) {
          stickyImage.src = imageSrc;
          stickyImage.alt = readCardName(card);
          stickyImage.hidden = false;
          if (stickyIcon) stickyIcon.hidden = true;
        } else {
          if (stickyImage) stickyImage.hidden = true;
          if (stickyIcon) stickyIcon.hidden = false;
        }
      }
      if (sticky) {
        sticky.setAttribute('data-bundle-name', readCardName(card));
        sticky.setAttribute('data-bundle-price', readCardPrice(card));
      }

      if (shouldTrack) {
        var selectParams = bundleEventParams(card, cards, 'bundle_card');
        emitOfferEvent('offer_bundle_card_selected', selectParams);
        emitOfferAlias('bundle_card_select', selectParams, true);
        emitOfferAlias('bundle_select', selectParams);
      }
    }

    function updateStickyVisibility() {
      if (!sticky || !cards.length) return;
      var footer = document.querySelector('.site-footer, footer');
      var footerTop = footer ? footer.getBoundingClientRect().top : Infinity;
      var selectorRect = selector.getBoundingClientRect();
      var stickyHeight = sticky.offsetHeight || 0;
      var hasPassedBundles = selectorRect.bottom < window.innerHeight - stickyHeight - 32;
      var beforeFooter = footerTop > window.innerHeight - 80;
      sticky.classList.toggle('is-visible', hasPassedBundles && beforeFooter);
    }

    cards.forEach(function (card) {
      updateVariant(card);

      var selectButton = card.querySelector('[data-smo-kit-select]');
      var variantSelect = card.querySelector('[data-smo-kit-variant-select]');
      var form = card.querySelector('[data-smo-bundle-form], [data-bundle-form]');

      card.addEventListener('click', function (event) {
        if (event.target.closest('a, button, input, select, label, summary, details')) return;
        selectCard(card, true);
      });

      card.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        if (event.target !== card) return;
        event.preventDefault();
        selectCard(card, true);
      });

      if (selectButton) {
        selectButton.addEventListener('click', function (event) {
          event.preventDefault();
          selectCard(card, true);
        });
      }

      if (variantSelect) {
        variantSelect.addEventListener('click', function (event) {
          event.stopPropagation();
        });
        variantSelect.addEventListener('change', function () {
          updateVariant(card);
          if (selectedCard === card) selectCard(card, false);
        });
      }

      var includesAccordion = card.querySelector('[data-smo-includes-accordion]');
      if (includesAccordion) {
        includesAccordion.addEventListener('toggle', function () {
          if (!includesAccordion.open) return;
          var includesParams = Object.assign(bundleEventParams(card, cards, 'bundle_inclusions'), {
            item_count: card.querySelectorAll('[data-smo-includes-accordion] li').length
          });
          emitOfferEvent('offer_inclusions_opened', includesParams);
          emitOfferAlias('bundle_inclusions_expand', includesParams, true);
        });
      }

      if (form) {
        form.addEventListener('submit', function () {
          selectCard(card, false);
          var addParams = bundleEventParams(card, cards, 'bundle_card');
          emitOfferEvent('offer_add_to_cart_clicked', addParams);
          emitOfferAlias('bundle_add_to_cart', addParams, true);
          emitOfferAlias('bundle_card_click', addParams);
        });
      }
    });

    if (sticky) {
      sticky.addEventListener('submit', function () {
        if (!selectedCard) return;
        var stickyParams = bundleEventParams(selectedCard, cards, 'sticky_atc');
        emitOfferEvent('offer_add_to_cart_clicked', stickyParams);
        emitOfferAlias('sticky_add_to_cart_click', stickyParams, true);
        emitOfferAlias('bundle_add_to_cart', stickyParams, true);
        emitOfferAlias('bundle_card_click', stickyParams);
      });
    }

    selectCard(selectedCard, false);
    updateStickyVisibility();
    window.addEventListener('scroll', updateStickyVisibility, { passive: true });
    window.addEventListener('resize', updateStickyVisibility);
  }

  root.querySelectorAll('[data-hero-cta]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      emitOfferEvent('offer_hero_cta_clicked');
      emitOfferAlias('offer_page_cta_click', { source: 'hero_cta' }, true);
      emitOfferAlias('hero_cta_click', { source: 'hero_cta' });
      scrollToHash(link, event);
    });
  });

  root.querySelectorAll('.smo-sticky-cta').forEach(function (oldStickyLink) {
    oldStickyLink.hidden = true;
  });

  root.querySelectorAll('[data-smo-bundle-selector], [data-bundle-section]').forEach(initBundleSelector);

  function scrollToHash(link, event) {
    var href = link.getAttribute('href') || '';
    if (!href || href.charAt(0) !== '#') return;
    var target = document.getElementById(href.slice(1));
    if (!target) return;
    if (event) event.preventDefault();

    var header = document.querySelector('.site-header, header');
    var headerOffset = header ? header.getBoundingClientRect().height : 0;
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset - 16;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });

    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', href);
    }
  }

  root.querySelectorAll('a[href^="#"]').forEach(function (link) {
    if (link.hasAttribute('data-hero-cta')) return;
    link.addEventListener('click', function (event) {
      scrollToHash(link, event);
    });
  });

  var faqToggle = root.querySelector('[data-faq-toggle]');
  var faqExtraItems = Array.prototype.slice.call(root.querySelectorAll('[data-faq-extra]'));
  function setFaqExpanded(expanded) {
    if (!faqToggle || !faqExtraItems.length) return;
    faqExtraItems.forEach(function (item) {
      item.hidden = !expanded;
      item.style.display = expanded ? '' : 'none';
    });
    faqToggle.setAttribute('aria-expanded', String(expanded));
    faqToggle.textContent = expanded
      ? (faqToggle.getAttribute('data-hide-label') || 'Show fewer FAQs')
      : (faqToggle.getAttribute('data-show-label') || 'Read more FAQs');
  }

  if (faqToggle && faqExtraItems.length) {
    setFaqExpanded(false);
    faqToggle.addEventListener('click', function () {
      var expanded = faqToggle.getAttribute('aria-expanded') !== 'true';
      setFaqExpanded(expanded);
      if (expanded) {
        emitOfferEvent('faq_expand', {
          source: 'offer_faq_toggle',
          faq_state: 'expanded'
        });
      }
    });
  }

  root.querySelectorAll('.smo-faq details').forEach(function (details) {
    details.addEventListener('toggle', function () {
      if (!details.open) return;
      var summary = details.querySelector('summary');
      emitOfferEvent('faq_expand', {
        source: 'offer_faq_item',
        question: summary ? summary.textContent.trim().slice(0, 160) : ''
      });
    });
  });

  function observeOnce(selector, eventName) {
    var target = root.querySelector(selector);
    if (!target || typeof IntersectionObserver !== 'function') return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          emitOfferEvent(eventName);
          if (eventName === 'offer_bundle_section_viewed') {
            emitOfferAlias('view_bundle_section');
          }
          observer.disconnect();
        }
      });
    }, { threshold: 0.35 });

    observer.observe(target);
  }

  observeOnce('[data-smo-bundle-selector], [data-bundle-section]', 'offer_bundle_section_viewed');

  var scrollMilestones = {
    offer_scroll_25: false,
    offer_scroll_50: false,
    offer_scroll_75: false
  };

  function trackScrollMilestones() {
    var documentElement = document.documentElement;
    var scrollTop = window.pageYOffset || documentElement.scrollTop || 0;
    var scrollable = Math.max(1, documentElement.scrollHeight - window.innerHeight);
    var depth = scrollTop / scrollable;

    if (!scrollMilestones.offer_scroll_25 && depth >= 0.25) {
      scrollMilestones.offer_scroll_25 = true;
      emitOfferEvent('offer_scroll_25', { scroll_percent: 25 });
      emitOfferAlias('scroll_25', { scroll_percent: 25 });
    }

    if (!scrollMilestones.offer_scroll_50 && depth >= 0.5) {
      scrollMilestones.offer_scroll_50 = true;
      emitOfferEvent('offer_scroll_50', { scroll_percent: 50 });
      emitOfferAlias('scroll_50', { scroll_percent: 50 });
    }

    if (!scrollMilestones.offer_scroll_75 && depth >= 0.75) {
      scrollMilestones.offer_scroll_75 = true;
      emitOfferEvent('offer_scroll_75', { scroll_percent: 75 });
      window.removeEventListener('scroll', trackScrollMilestones);
    }
  }

  window.addEventListener('scroll', trackScrollMilestones, { passive: true });
})();
